<script setup lang="ts">
import {Popover} from '@headlessui/vue'
import Header from '@/Layouts/App/Components/Header.vue'
import MobileMenu from '@/Layouts/App/Components/Mobile/MobileMenu.vue'
</script>
<template>
  <Popover
    v-slot="{ open }"
    as="header"
    class="pb-24 bg-linear-to-r from-primary-800 to-primary-500 dark:bg-linear-to-b dark:from-primary-900 dark:to-neutral-950"
  >
    <Header :open="open" />
    <MobileMenu :open="open" />
  </Popover>
</template>
